import { Component, Inject, OnInit  } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActaModelData } from 'src/app/model/ActaModelData';
import { MatDialogRef } from '@angular/material/dialog';
import { ValidacionService } from 'src/app/service/validacion.service';
import { apiService } from 'src/app/service/api.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-acta',
  templateUrl: './modal-acta.component.html',
  styleUrls: ['./modal-acta.component.css']
})
export class ModalActaComponent implements OnInit {


  modelReference: any;
  fecha1Campo1;
  fecha1Campo2;
  fecha1Campo3;
  fecha2Campo1;
  fecha2Campo2;
  fecha2Campo3;
  actaData = new ActaModelData();
  jardineSelected;
  buttonEstado:boolean = true;

  horaInicio1 = {hour: 0, minute:0};
  horaFin1 = {hour: 0, minute:0};
  horaInicio2 = {hour: 0, minute:0};
  horaFin2 = {hour: 0, minute:0};
  buttonCrear:boolean = false;

  constructor(private modal: NgbModal,  public dialogRef: MatDialogRef<ModalActaComponent>, private validacionService: ValidacionService,
    private api: apiService) { }

  ngOnInit(): void {
    this.getActa();
  }

  closeModal(){
    this.dialogRef.close()
  }
  

  getActa(){
    this.jardineSelected = this.api.dataJardin
    const param = this.api.dataJardin.idJardinPeriodo
    this.validacionService.API_POST_getActaValidacion(param).subscribe((response: any) => {
      if(response.payload.idEstado == 1){
        this.buttonEstado = false
      }
      let jornada1 = new Date(response.payload.fechaInicio1);
      let jornada2 = new Date(response.payload.fechaInicio2);
      let jornada1Fin = new Date(response.payload.fechaFin1);
      let jornada2Fin = new Date(response.payload.fechaFin2);


      jornada1.setHours( jornada1.getHours() - 3 );
      jornada2.setHours( jornada2.getHours() - 3 );
      jornada1Fin.setHours( jornada1Fin.getHours() - 3 );
      jornada2Fin.setHours( jornada2Fin.getHours() - 3 );

      jornada1.setTime( jornada1.getTime() + jornada1.getTimezoneOffset()*60*1000 );
      jornada2.setTime( jornada2.getTime() + jornada2.getTimezoneOffset()*60*1000 );   
      jornada1Fin.setTime( jornada1Fin.getTime() + jornada1Fin.getTimezoneOffset()*60*1000 );
      jornada2Fin.setTime( jornada2Fin.getTime() + jornada2Fin.getTimezoneOffset()*60*1000 );   
      var jornada1Hora = {hour:  jornada1.getHours(), minute: jornada1.getMinutes()};
      var jornada2Hora = {hour:  jornada2.getHours(), minute: jornada2.getMinutes()};
      var jornada1fecha = {"year": jornada1.getFullYear(),"month": jornada1.getMonth() + 1, "day": jornada1.getDate()};
      var jornada2fecha = {"year": jornada2.getFullYear(),"month": jornada2.getMonth() + 1, "day": jornada2.getDate()};
      var jornada1HoraFin = {hour:  jornada1Fin.getHours(), minute: jornada1Fin.getMinutes()};
      var jornada2HoraFin = {hour:  jornada2Fin.getHours(), minute: jornada2Fin.getMinutes()};
      this.actaData.fechaInicioReal1 = jornada1fecha
      this.actaData.fechaInicioReal2 = jornada2fecha
      this.horaInicio1 = jornada1Hora
      this.horaFin1 = jornada1HoraFin    
      this.horaInicio2 = jornada2Hora
      this.horaFin2 = jornada2HoraFin
      this.actaData.observaciones = response.payload.observacionDirectora
      this.actaData.duracion1 = response.payload.duracion1
      this.actaData.duracion2 = response.payload.duracion2
      this.actaData.nombreDirectora = response.payload.nombreDirectora
      this.actaData.validador1= response.payload.nombreValidador1;
      this.actaData.cedulaId1= response.payload.rutValidador1;
      this.actaData.validador2= response.payload.nombreValidador2;
      this.actaData.cedulaId2= response.payload.rutValidador2;

    },
    (err) => {
      console.log("error"+err)
    });
  
  }
  

  enviarActaFirmada(){
    const param = this.api.dataJardin.idJardinPeriodo
    this.validacionService.API_POST_getFirmaActa(param).subscribe((response: any) => {
      Swal.fire({
        title: 'Listo',
        text: 'Acta Firmada correctamente',
        icon: 'success',
        confirmButtonText: 'OK'
      })
      this.dialogRef.close()
     
    },
    (err) => {
      console.log("error"+err)
      this.dialogRef.close()
    });
  }
  


  duracionGetSesion1(){
    let duracion1;
    if(this.actaData.fechaInicioReal1 != undefined){
      var start1 = new Date(this.actaData.fechaInicioReal1.year, this.actaData.fechaInicioReal1.month , this.actaData.fechaInicioReal1.day, this.horaInicio1.hour, this.horaInicio1.minute, 0, 0);
      var end1 =  new Date(this.actaData.fechaInicioReal1.year, this.actaData.fechaInicioReal1.month , this.actaData.fechaInicioReal1.day, this.horaFin1.hour, this.horaFin1.minute, 0, 0);
      
      if(start1.getTime() < end1.getTime()){
        var difference = start1.getTime() - end1.getTime(); // This will give difference in milliseconds
        var resultInMinutes = Math.round(difference / 60000);
        duracion1 =  resultInMinutes
        duracion1 = Math.abs(duracion1);
        var horas = parseInt((duracion1 / 60).toString());
        var minutos = (duracion1 % 60);
        if(minutos<10){
          duracion1 = horas +":0"+minutos;
        }else{
          duracion1 = horas +":"+minutos;
        }
      }else{
  
        duracion1 = "Error"
      }
    }
    return duracion1;
  }
  
  
   duracionGetSesion2(){
    let duracion2;
    if(this.actaData.fechaInicioReal2 != undefined){
      var start1 = new Date(this.actaData.fechaInicioReal2.year, this.actaData.fechaInicioReal2.month , this.actaData.fechaInicioReal2.day, this.horaInicio2.hour, this.horaInicio2.minute, 0, 0);
      var end1 =  new Date(this.actaData.fechaInicioReal2.year, this.actaData.fechaInicioReal2.month , this.actaData.fechaInicioReal2.day, this.horaFin2.hour, this.horaFin2.minute, 0, 0);
      if(start1.getTime() < end1.getTime()){
        var difference = start1.getTime() - end1.getTime(); // This will give difference in milliseconds
        var resultInMinutes = Math.round(difference / 60000);
        duracion2 =  resultInMinutes
        duracion2 = Math.abs(duracion2);
        var horas = parseInt((duracion2 / 60).toString());
        var minutos = (duracion2 % 60);
        if(minutos<10){
          duracion2 = horas +":0"+minutos;
        }else{
          duracion2 = horas +":"+minutos;
        }
      }else{
  
        duracion2 = "Error"
      }
  
    }
    return duracion2;
  }



}
